import styled from 'styled-components';
import AlreadyHaveAnAccount from 'components/auth/components/AlreadyHaveAnAccount';
import PageHeader from 'components/auth/components/PageHeader';
import { FlexCol } from 'components/primitives/flex';
import { useRouter } from 'next/router';
import Button from 'components/ui/Button/Button';
import { useTrackEvent } from 'hooks/useAnalyticsTrack';
import { useLocalStorage } from 'beautiful-react-hooks';
import Cookies from 'js-cookie';
import boatsetterPaths from 'utils/boatsetterPaths';
import SocialLoginButtons from '../components/SocialLoginButtons';
import Envelope from '../icons/Envelope.svg';

export default function WelcomeSignupPage() {
  const router = useRouter();
  const eventIntakeTrack = useTrackEvent();
  const [galacticaSession] = useLocalStorage('galactica_session', '');

  return (
    <FlexCol gap="20px">
      <PageHeader title="Create account" />
      <StyledButton data-testid="sign-up-button">
        <Button
          fullWidth
          onClick={() => {
            eventIntakeTrack('UserSignedUpWithEmail', {
              anonymousId: Cookies.get('uuid') || '',
              sessionId: galacticaSession || '',
              appScreen: router.pathname,
            });

            router.push({
              pathname: `${boatsetterPaths.signUp}/email`,
              query: router.query,
            });
          }}
          text={
            <>
              <Envelope />
              <span>Sign up with email</span>
            </>
          }
        />
      </StyledButton>
      <SocialLoginButtons orText="or" compact={false} ignoreSmallScreen isSignUpMode />
      <AlreadyHaveAnAccount />
    </FlexCol>
  );
}

const StyledButton = styled.div`
  display: flex;

  span {
    padding-left: 10px;
  }

  svg {
    box-sizing: content-box;
    padding-top: 2px;
  }
`;
